import { render, staticRenderFns } from "./ReplacementByRegion.vue?vue&type=template&id=7d96558b"
import script from "./ReplacementByRegion.vue?vue&type=script&lang=js"
export * from "./ReplacementByRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports